import React from 'react';
import { TrendingDown, TrendingUp, Minus } from 'lucide-react';

const Shift = ({ s }) => {
  if (s.delta_days == null) return <span className="text-slate-400">—</span>;
  const faster = s.delta_days < 0;
  const flat = s.delta_days === 0;
  const Icon = flat ? Minus : faster ? TrendingDown : TrendingUp;
  const cls = flat ? 'bg-slate-100 text-slate-500' : faster ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-semibold tabular-nums ${cls}`} title={`${s.from_quarter} → ${s.to_quarter}`} data-testid={`do-velocity-trend-delta-${s.stage}`}>
      <Icon className="w-3 h-3" />{s.delta_days > 0 ? '+' : ''}{s.delta_days}d{s.delta_pct != null && <span className="font-normal opacity-80">({s.delta_pct > 0 ? '+' : ''}{s.delta_pct}%)</span>}
    </span>
  );
};

/** Quarter-over-quarter avg days per stage (bucketed by the quarter deals left the stage) — shows whether coaching is shortening stages. */
export const StageVelocityTrend = ({ trend }) => {
  const qs = trend?.quarters || [];
  const hasData = (trend?.stages || []).some((s) => s.points.some((p) => p.n));
  if (!qs.length || !hasData) return <p className="text-xs text-slate-400" data-testid="do-velocity-trend-empty">No completed stage stints in the last {qs.length || 6} quarters yet — the trend fills in as deals move between stages.</p>;
  const maxDays = Math.max(1, ...trend.stages.flatMap((s) => s.points.map((p) => p.avg_days || 0)));
  return (
    <table className="w-full text-[11px]" data-testid="do-velocity-trend">
      <thead className="text-slate-400 text-left">
        <tr>
          <th className="py-1 pr-2 font-medium">Stage</th>
          {qs.map((q) => <th key={q.key} className="py-1 px-2 font-medium text-right whitespace-nowrap">{q.key}{q.current && <span className="ml-1 text-[9px] font-normal">to date</span>}</th>)}
          <th className="py-1 pl-2 font-medium text-right whitespace-nowrap">Latest shift</th>
        </tr>
      </thead>
      <tbody>
        {trend.stages.map((s) => (
          <tr key={s.stage} className="border-t border-slate-100" data-testid={`do-velocity-trend-row-${s.stage}`}>
            <td className="py-1.5 pr-2 font-medium text-slate-700 whitespace-nowrap">{s.label}</td>
            {s.points.map((p) => (
              <td key={p.quarter} className="py-1.5 px-2 text-right tabular-nums align-bottom">
                {p.avg_days == null ? <span className="text-slate-300">—</span> : (
                  <div className="inline-flex flex-col items-end gap-0.5">
                    <span className="text-slate-700">{p.avg_days}d<span className="ml-1 text-[9px] text-slate-400">n={p.n}</span></span>
                    <span className="block h-1 rounded bg-[#0F2040]/70" style={{ width: `${Math.max(4, (p.avg_days / maxDays) * 56)}px` }} />
                  </div>
                )}
              </td>
            ))}
            <td className="py-1.5 pl-2 text-right"><Shift s={s} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
